export function RolesService ({socket}) {

    const events = new andy.EventManager();

    const dataset = new andy.Dataset('andy.admin.roles');
    
    return  {
        dataset,
        on: events.addEventListener
    }
}